// extracted by mini-css-extract-plugin
export default {"loginHeader":"login_loginHeader__9PLAl"};